import { observable } from "mobx";

class TourJobFile {
  /**
   * @property {number|null}
   */
  @observable tourJobFileId = null;

  /**
   * @property {number|null}
   */
  @observable tourJobId = null;

  /**
   * @property {string|null}
   */
  @observable name = null;

  /**
   * @property {string|null}
   */
  @observable mimeType = null;

  /**
   * @property {string|null}
   */
  @observable fileUrl = null;

  constructor({ tourJobFileId = null, tourJobId = null, name = null, mimeType = null, fileUrl = null }) {
    this.tourJobFileId = tourJobFileId;
    this.tourJobId = tourJobId;
    this.name = name;
    this.mimeType = mimeType;
    this.fileUrl = fileUrl;
  }
}

export default TourJobFile;
